export default __webpack_public_path__ + "static/media/avatar.690dda62.png";